export enum OsType {
  /**
   * 윈도우
   */
  WINDOWS = "WINDOWS",

  /**
   * 맥
   */
  MAC = "MAC",

  /**
   * 리눅스
   */
  LINUX = "LINUX",

  /**
   * 공용
   */
  COMMON = "COMMON",

}

export const OsTypes = [
  {
    value: OsType[OsType.WINDOWS],
    label: 'Windows',
  },
  {
    value: OsType[OsType.MAC],
    label: 'Mac',
  },
  {
    value: OsType[OsType.LINUX],
    label: 'Linux',
  },
  {
    value: OsType[OsType.COMMON],
    label: '공용',
  },
]